export default __webpack_public_path__ + "static/media/2-bg.67802632.png";